import classNames from 'classnames';

import IconMail from '../components/icons/IconMail';
import IconPhone from '../components/icons/IconPhone';
import IconWebsite from '../components/icons/IconWebsite';
import { linkClassNames, marginsClassNames } from '../utils/style';

const headerLinkClassNames = classNames(linkClassNames, 'text-header-text font-extralight!', 'print:text-text');
const infoClassNames = 'flex items-center gap-3 justify-center';

const url = 'cv.marcmalignan.com';
const email = 'mhmalignan@gmail.com';
const phone = '+0033631719227';
const phoneDisplay = '06.31.71.92.27';

const iconSize = 18;
const iconSizePhone = 22;

const Header = () => (
  <header
    className={classNames(
      marginsClassNames,
      'relative flex items-center justify-between pt-6 pb-8',
      // 'bg-linear-to-br from-header to-header-2 text-header-text',
      'not-print:bg-linear-to-br from-header to-header-2 not-print:text-header-text print:bg-page print:text-text',
      'not-print:max-desktop:pt-4 not-print:max-desktop:pb-5',
    )}
  >
    {/* Logo */}
    <div>
      <h1 className="pb-2 font-title text-[3.2rem] leading-9 text-accent">
        marc
        <br />
        malignan
      </h1>
      <hr className="my-4 border-t-[.15rem] border-accent" />
      <div>Développeur Front-end Senior</div>
    </div>

    {/* Info desktop / print */}
    <div className="not-print:max-desktop:hidden grow flex flex-col items-end justify-center">
      <div className="flex flex-col gap-1.5 items-start">
        <div className={classNames(infoClassNames, 'not-print:hidden')}>
          <IconWebsite className="text-accent" size={iconSize} />
          <a className={headerLinkClassNames} href={`https://${url}`} target="_blank">
            {url}
          </a>
        </div>
        <div className={infoClassNames}>
          <IconMail className="text-accent" size={iconSize} />
          <a className={headerLinkClassNames} href={`mailto:${email}`} target="_blank">
            {email}
          </a>
        </div>
        <div className={infoClassNames}>
          <IconPhone className="text-accent" size={iconSize} />
          <a className={headerLinkClassNames} href={`tel:${phone}`}>
            {phoneDisplay}
          </a>
        </div>
      </div>
    </div>

    {/* Infos mobile */}
    <div className="desktop:hidden print:hidden absolute bottom-3 right-2 flex items-center">
      <a className="block p-2" href={`mailto:${email}`} target="_blank">
        <IconMail size={iconSizePhone} />
      </a>
      <a className="block p-2" href={`tel:${phone}`}>
        <IconPhone size={iconSizePhone - 4} />
      </a>
    </div>
  </header>
);

export default Header;
